module.exports = __webpack_public_path__ + "static/new_editor-786449e2ceb1ddff9485032a3b1b4a67.svg";